import React from 'react';
import PropTypes from 'prop-types';

// Components
import Measure from '../../../../node_module_clones/react-measure/src/Measure';
import EditableTitle from '../../../components/editableTitle/EditableTitle';

// Constants
import { BOARD_DEFAULT_TITLE, CURRENT_BOARD_HEADER_TITLE_EDITOR_KEY } from '../../../../common/boards/boardConstants';

// Styles
import './CurrentBoardHeaderTitle.scss';

const CurrentBoardHeaderTitle = ({
    shouldMeasureWidth,
    setTitleWidth,
    filterQuery,
    currentBoard,
    currentBoardId,
    isEditable,
}) => (
    <Measure
        whitelist={['width']}
        onMeasure={({ width }) => setTitleWidth && setTitleWidth(width)}
        shouldMeasure={shouldMeasureWidth}
    >
        <div className="CurrentBoardHeaderTitle">
            <EditableTitle
                selectAllOnEdit
                filterQuery={filterQuery}
                element={currentBoard}
                elementId={currentBoardId}
                isEditable={isEditable}
                editorKey={CURRENT_BOARD_HEADER_TITLE_EDITOR_KEY}
                initialValue={BOARD_DEFAULT_TITLE}
            />
        </div>
    </Measure>
);

CurrentBoardHeaderTitle.propTypes = {
    currentBoardId: PropTypes.string,
    filterQuery: PropTypes.string,
    shouldMeasureWidth: PropTypes.bool,
    isEditable: PropTypes.bool,
    currentBoard: PropTypes.object,
    setTitleWidth: PropTypes.func,
};

export default CurrentBoardHeaderTitle;
